export default __webpack_public_path__ + "static/media/rocket.ed88e977.svg";